import { render, staticRenderFns } from "./Navlink.vue?vue&type=template&id=3575e0be&scoped=true&"
import script from "./Navlink.vue?vue&type=script&lang=js&"
export * from "./Navlink.vue?vue&type=script&lang=js&"
import style0 from "./Navlink.vue?vue&type=style&index=0&id=3575e0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575e0be",
  null
  
)

export default component.exports